import React from "react"
import { compose } from 'redux'
import { duckify, filterDuck } from "../../utils/duckify"
import { entity as schoolYearsDuck } from "../../ducks/schoolYears"
import { flashMessages } from "../../ducks"

import SelectPicker from "../SelectPicker/SelectPicker"
import FlashRoot from "../FlashMessage/FlashRoot"

const DefaultForReportingDropdown = ({ schoolYears, updateDefaultReporting }) => {
  const currentDefault = schoolYears.find(schoolYear => schoolYear.default_for_reporting) || {}

  const handleChange = event => {
    updateDefaultReporting(event)
  }

  return (
    <div className="default-for-reporting-dropdown">
      <FlashRoot />
      <strong>Default for Reporting</strong>
      <span className="track-silo track-silo-default-for-reporting">
        <SelectPicker
          value={currentDefault.id}
          onChange={handleChange}
          standardButton={true}
          options={
            schoolYears.map(schoolYear => ({
              value: schoolYear.id,
              label: schoolYear.name
            }))
          }
        />
      </span>
      Choose a default term to use for reporting throughout the system. (You’ll be able to view other terms using filter options.)
    </div>
  )
}

const mapDucksToProps = () => ({
  schoolYears: filterDuck(schoolYearsDuck, { excluding_archived: true })
})

const mapDispatchToProps = dispatch => ({
  updateDefaultReporting: (schoolYearId) => dispatch(schoolYearsDuck.actions.setDefaultForReporting(schoolYearId))
    .then(res => dispatch(flashMessages.actions.show({
      message: res.flash,
      type: 'success',
      dismissible: true
    })))
    .then(() => dispatch(schoolYearsDuck.actions.markDirty()))
    .catch(err => dispatch(flashMessages.actions.show({
      message: err.error,
      type: 'danger',
      dismissible: true
    }))
    )
})

export default compose(
  duckify(mapDucksToProps, () => ({}), mapDispatchToProps)
)(DefaultForReportingDropdown)
